export function hmToMinutes(hours: number, minutes: number): number {
  return Math.max(0, Math.trunc(hours) * 60 + Math.trunc(minutes));
}

export function minutesToHm(total: number): string {
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}
